var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 100px)"}},[_c('SeeksRelationGraph',{ref:"seeksRelationGraph",attrs:{"options":_vm.graphOptions,"on-node-click":_vm.onNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }